import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import TriggerEventNodePreview from "../../features/sequence/node_previews/TriggerEventNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import { compactSearchableStrings } from "./SearchableInteractionValues";

export interface ITriggerEvent extends Interaction {
  eventName: string;
}

export const triggerEventInteraction = (): InteractionFactoryEntity => {
  const view = <></>;

  const create = (getKeys: (amount: number) => string[]): ITriggerEvent => {
    return {
      id: GetNewGuid(),
      name: "Trigger Event",
      type: InteractionType.TriggerEvent,
      eventName: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ITriggerEvent => {
    return interaction as ITriggerEvent;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): ITriggerEvent => {
    return {
      ...(interaction as ITriggerEvent),
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as ITriggerEvent;
    return getMatchingResults(
      compactSearchableStrings(interaction.name, converted.eventName),
      takeName,
      interaction,
      "Trigger Event"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    return [];
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <TriggerEventNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "Trigger Event",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
